export default __webpack_public_path__ + "static/alloydb-ea4960dffb0eef2a6abc70e8a0f893a1.svg";